import React from "react";
import { NavLink, Link } from "react-router-dom";

/**
 * MobileDrawer — presentational off-canvas menu for the site header.
 * Rendered by Header on small viewports.
 */
export default function MobileDrawer({ open, nav, onClose }) {
  return (
    <div
      className={`mobile-drawer ${open ? "open" : ""}`}
      onClick={(e) => {
        if (e.target === e.currentTarget) onClose();
      }}
      aria-hidden={!open}
    >
      <aside className="mobile-drawer__panel" aria-label="Mobile menu">
        {nav.map((n) => (
          <NavLink
            key={n.to}
            to={n.to}
            end={n.to === "/"}
            className={({ isActive }) => (isActive ? "is-active" : "")}
            data-testid={`mobile-nav-${n.label.toLowerCase()}`}
          >
            {n.label}
          </NavLink>
        ))}
        <div style={{ marginTop: 20 }}>
          <Link to="/contact#quote" className="btn btn--primary" data-testid="mobile-cta-quote">
            Get Quote
          </Link>
        </div>
      </aside>
    </div>
  );
}
